var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrigo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 230.6 198",
    style: {
      enableBackground: "new 0 0 230.6 198"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFDA26;}\n\t.st1{fill:#BCBCBB;}\n\t.st2{fill:#C6CDD7;}\n\t.st3{fill:#334D6F;}\n\t.st4{fill:#95A2B4;}\n\t.st5{fill:#C09825;}\n\t.st6{fill:#EEEEEE;}\n\t.st7{fill:#FDF191;}\n\t.st8{fill:url(#SVGID_1_);}\n\t.st9{fill:url(#SVGID_2_);}\n\t.st10{fill:#FCF191;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REPERES"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.07,148.83l0.39-93.44l-53.91,28.99l-0.39,93.09c0,0.15,0,0.31,0.01,0.45c0.07,1.83,0.64,3.17,1.68,4.02 l0.74,0.48c1.34,0.67,2.92,0.51,4.75-0.48L160.82,161c1.99-1.07,3.7-2.79,5.11-5.16C167.35,153.46,168.06,151.12,168.07,148.83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.56,82.87l26.75-14.31l0.01-1.63l6.51-3.62l-0.01,1.76l20.65-11.08l0.02-3.81 c0.01-2.2-0.63-3.75-1.93-4.65c-0.03-0.03-0.06-0.05-0.1-0.07l-0.27-0.16c-1.29-0.72-2.82-0.64-4.58,0.23 c-0.1,0.05-0.21,0.11-0.31,0.16l-39.47,20.96c-0.18,0.1-0.36,0.2-0.53,0.31c-1.42,0.87-2.68,2.09-3.8,3.67 c-0.27,0.37-0.53,0.76-0.77,1.17c-1.43,2.39-2.14,4.73-2.15,7.02l-0.01,1.23L114.56,82.87z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.41,96.64l2.3,1.3l-3.3,1.61l-2.16-1.33L122.41,96.64z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M120.25,95.31l4.46,2.62l-3.3,1.61l-4.33-2.65L120.25,95.31z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M117.08,96.89l4.33,2.65v2.89l-4.33-2.76V96.89z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M117.08,128.49l4.33,2.65v2.89l-4.33-2.76V128.49z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.41,131.13l2.3,1.3l-3.3,1.61l-2.16-1.33L122.41,131.13z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M121.4,134.03l3.3-1.61V97.93l-3.3,1.61V134.03z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M121.4,134.03l-2.16-1.33V98.22l2.16,1.33V134.03z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.32,66.93l6.51-3.62l-0.01,1.76l-6.51,3.49L141.32,66.93z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M65.09,151.31l43.51,26.26c-0.07-0.05-0.14-0.1-0.21-0.15c-1.41-0.87-2.11-2.46-2.1-4.75l0.41-97.07 l-42.9-25.55l-0.41,96.79C63.38,148.9,63.95,150.4,65.09,151.31 M107.3,173.29c-0.01,1.93,0.46,3.38,1.42,4.35l7.14,4.31 c-1.05-0.85-1.61-2.19-1.68-4.02c-0.01-0.15-0.01-0.3-0.01-0.45l0.39-93.09l0.01-1.51l0.01-2.81l-6.87-3.89L107.3,173.29z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M114.55,84.38l0.01-1.51l21.82-11.68l6.51-3.49l25.59-13.71l-0.01,1.4L114.55,84.38z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M114.35,62.82c0.2-0.13,0.4-0.24,0.61-0.35l39.46-20.96c1.72-0.91,3.21-1.11,4.47-0.6l7.3,4.39 c-1.29-0.72-2.82-0.64-4.58,0.23c-0.1,0.05-0.21,0.11-0.31,0.16l-39.47,20.96c-0.18,0.1-0.36,0.2-0.53,0.31L114.35,62.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -8304.332,
    y1: -4856.1416,
    x2: -8209.3086,
    y2: -5025.2422,
    gradientTransform: "matrix(-0.0698 -2.550429e-03 2.908816e-04 -0.0692 -460.912 -291.9434)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCF191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C09825"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M109.86,67.62c1.27-2.12,2.77-3.72,4.49-4.8l6.94,4.15c-1.42,0.87-2.68,2.09-3.8,3.67 c-0.27,0.37-0.53,0.76-0.77,1.17c-1.43,2.39-2.14,4.73-2.15,7.02l-0.01,1.23l-6.87-3.89l0.01-1.53 C107.72,72.35,108.44,70,109.86,67.62z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.85,67c1.26-2.12,2.75-3.71,4.47-4.79c0.22-0.13,0.43-0.25,0.64-0.36l39.46-20.96 c1.69-0.91,3.17-1.11,4.42-0.61l1.06,0.63c-1.27-0.52-2.76-0.32-4.47,0.6l-39.46,20.96c-0.21,0.11-0.41,0.23-0.61,0.35 c-1.72,1.08-3.22,2.68-4.49,4.8c-1.43,2.39-2.14,4.73-2.15,7.02l-0.01,1.53l-0.41,97.12c-0.01,1.93,0.46,3.38,1.42,4.35 l-0.11-0.07c-0.07-0.05-0.14-0.1-0.21-0.15c-1.41-0.87-2.11-2.46-2.1-4.75l0.41-97.07l0.01-1.58 C106.71,71.72,107.43,69.38,108.85,67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -7944.7446,
    y1: -4630.5537,
    x2: -7828.5552,
    y2: -4828.9839,
    gradientTransform: "matrix(-0.0698 -2.550429e-03 2.908816e-04 -0.0692 -460.912 -291.9434)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCF191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C09825"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M113.32,62.21c-1.72,1.08-3.21,2.67-4.47,4.79c-1.43,2.39-2.14,4.73-2.15,7.02l-0.01,1.58l-42.9-25.55 l0.01-1.85c0.01-2.3,0.73-4.64,2.15-7.02c1.41-2.37,3.1-4.08,5.07-5.14L113.32,62.21z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M110.52,15.04c0.02-0.01,0.03-0.02,0.05-0.03c1.8-0.95,3.98-0.83,5.73,0.22l41.53,25.03 c-1.25-0.5-2.72-0.3-4.42,0.61l-39.46,20.96c-0.21,0.11-0.42,0.23-0.64,0.36l-42.3-26.18c0.01-0.01,0.03-0.01,0.03-0.02 L110.52,15.04z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrigo);
export default __webpack_public_path__ + "static/media/frigo.46893928b896e1cd3b543558318630df.svg";
export { ForwardRef as ReactComponent };